const AVATAR_SIZE_STEPS = [
    { px: 16, token: '2xs', where: '방송 채팅, 라이브 상품 목록의 판매자, 힛 갤러리 카드의 구매자' },
    { px: 20, token: 'xs', where: '방송 카드의 판매자, 주문 내역의 판매자·구매자, 판매 완료 목록' },
    { px: 24, token: 's', where: '라운지 댓글, 채팅 말풍선, 낙찰 배너, 라이브 상품 상세' },
    { px: 28, token: 's-plus', where: '방송 시청자 순위, 힛 갤러리 올리기' },
    { px: 32, token: 'm', where: '채팅방 상단, 라운지 글 작성자, 방송 화면 상단' },
    { px: 36, token: 'm-plus', where: '커뮤니티 목록, 사용자 정보 줄, 힛 갤러리 상세' },
    { px: 40, token: 'l', where: '채팅 목록, 방송 채팅 메뉴(크기를 정하지 않은 프로필 사진 포함)' },
    { px: 48, token: 'xl', where: '판매자 문의 카드, 방송 종료 창' },
    { px: 56, token: '2xl', where: '차단 목록' },
    { px: 64, token: '3xl', where: '채팅 상대 프로필, 팔로우 해제·팔로워 삭제 확인 창' },
    { px: 80, token: '4xl', where: '프로필 화면, 프로필 수정' },
];
export const AVATAR_FIELDS = [
    ...AVATAR_SIZE_STEPS.map(({ px, token, where }) => ({
        key: `avatar.size.px${px}`,
        label: `${px}px 프로필 사진 크기`,
        help: `지금 ${px}px로 그리는 프로필 사진(${where})의 크기입니다. 같은 크기를 쓰는 모든 화면이 함께 바뀝니다.`,
        group: '크기',
        type: 'size',
        tokenGroup: 'dimension',
        defaultValue: `$dimension.${token}`,
        min: 12,
        max: 120,
    })),
    {
        key: 'avatar.radius',
        label: '모서리 둥글기',
        help: '프로필 사진 모서리의 둥글기입니다. 기본(full)은 원형이고, 작은 값을 고르면 둥근 사각형이 됩니다(사진 크기의 절반보다 크면 원형). 커뮤니티 목록처럼 화면이 모양을 따로 정한 곳은 그대로입니다.',
        group: '모양',
        type: 'size',
        tokenGroup: 'radius',
        defaultValue: '$radius.full',
        min: 0,
        max: 9999,
    },
    {
        key: 'avatar.initial.scale',
        label: '첫 글자 크기',
        help: '사진이 없을 때 닉네임 첫 글자를 보여 주는데, 그 글자 크기를 프로필 사진 크기의 몇 %로 할지입니다.',
        group: '모양',
        type: 'integer',
        defaultValue: 40,
        min: 25,
        max: 60,
        unit: '%',
    },
    {
        key: 'avatar.border.width',
        label: '테두리 두께',
        help: '프로필 사진 둘레 테두리의 두께입니다. 0이면 테두리가 없습니다(지금 모양).',
        group: '테두리',
        type: 'integer',
        defaultValue: 0,
        min: 0,
        max: 4,
        unit: 'px',
    },
    {
        key: 'avatar.border.color',
        label: '테두리 색',
        help: '테두리 두께가 1px 이상일 때의 테두리 색입니다(밝은·어두운 화면 모드에 맞춰 바뀌는 색 토큰).',
        group: '테두리',
        type: 'enum',
        defaultValue: 'neutral-primary',
        options: [
            { value: 'neutral-primary', label: '연한 회색 (border.neutral.primary)' },
            { value: 'neutral-secondary', label: '진한 회색 (border.neutral.secondary)' },
            { value: 'static-white', label: '흰색 (border.static.white)' },
            { value: 'static-black', label: '검은색 (border.static.black)' },
        ],
    },
];
//# sourceMappingURL=avatar.js.map